import {
  CONSTANTS,
  GRAPH_TYPES,
  REPORT_TYPES,
  VERTICALS,
} from "../../../constants/app-constant";
import { groupBy } from "../../../utility/common-methods";
import { getRandomUniqueColor, getLineGraphFormat } from "./format-utils";

const { PIE, TABLE, BAR_STACKED_EQUAL_HEIGHT, AREA } = GRAPH_TYPES;

const {
  REPORTS: { TYPES },
} = CONSTANTS;
export const formatedDataBySentiment = (
  d = [],
  graph_type,
  isLineGraph,
  type,
  report_type,
  isEmbededWidget = false
) => {
  try {

    const reportType = TYPES.filter((t) => t.id == report_type)[0];
    const {
      graphDataType: { print, online },
      groupByField,
      entityKey,
      countKey,
    } = reportType;
    const rType = type === VERTICALS.V_PRINT ? print : online;
    let data = d[rType] && d[rType].returnData?.graphdata;
    data = Object.entries(data)
      .sort(([, a], [, b]) => b[countKey] - a[countKey])
      .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
    const graphColors = getRandomUniqueColor(data.length);
    let labels = Object.keys(data);
    let BGcolors = [];
    let tempData = [];
    let hcPieChartData = [];
    // data.length && data.sort((a, b) => b[countKey] - a[countKey]);
    labels.forEach((elm, index) => {
      if (parseInt(data[elm][countKey], 10) > 0) {
        BGcolors.push(graphColors[index]);
        tempData.push(parseInt(data[elm][countKey], 10));
        hcPieChartData.push({
          name: elm,
          y: parseInt(data[elm][countKey], 10),
          backgroundColor: graphColors[index],
        });
      }
    });
    const staticLabel = rType.toLowerCase().includes("ccm")
      ? "CCM"
      : rType.toLowerCase().includes("mav")
        ? "MAV"
        : "Count";
    const datasets = [
      {
        label: "",
        backgroundColor: BGcolors && BGcolors[0],
        borderColor: BGcolors,
        borderWidth: 1,
        data: tempData,
        barThickness: "flex",
        fill: graph_type === AREA ? "start" : false,
        lineTension: 0,
      },
    ];
    return {
      labels,
      datasets,
      hcPieChartData,
    };
  } catch (e) {
    return {
      datasets: [],
      labels: [],
    };
  }
};



export const formatSentimentTableData = (d = [],
  graphType,
  isLineGraph,
  type,
  report_type,
  isEmbededWidget = false) => {
  const reportType = TYPES.filter((t) => t.id == report_type)[0];
  const {
    graphDataType: { print, online },
    groupByField,
    entityKey,
    countKey,
  } = reportType;

  const result = d;
  const entities = result && result[result.sequence[0]].returnData.entities;
  const color = entities && getRandomUniqueColor(entities.length);
  let labels = [];
  const dataSet = [];
  const dataObj = result && result[result?.sequence[0]].returnData?.graphdata;
  const resultLabels = Object.keys(dataObj);
  labels = resultLabels;
  const staticLables = ["Positive", "Neutral", "Negative"];
  staticLables.forEach((lab, idx) => {
    const data = [];
    const barThickness = "flex";
    const borderColor = color[idx];
    const backgroundColor = color[idx];
    const borderWidth = 1;
    let label = lab;

    entities && entities.forEach((ent) => {
      if (dataObj[ent.entity_name].hasOwnProperty(lab)) {
        if (parseInt(dataObj[ent.entity_name][lab][countKey]) > 0) {
          const currValEnt = parseInt(dataObj[ent.entity_name][lab][countKey]);
          data.push(currValEnt + '%');
        }
      }
      else {
        data.push(0);
      }
    });
    dataSet.push({ label, backgroundColor, barThickness, borderColor, borderWidth, data, fill: false, lineTension: 0 });
  });
  return ({ labels, datasets: dataSet });
}
export const formatSentimentData = (d = [],
  graphType,
  isLineGraph,
  type,
  report_type,
  isEmbededWidget = false) => {
  const reportType = TYPES.filter((t) => t.id == report_type)[0];
  const {
    graphDataType: { print, online },
    groupByField,
    entityKey,
    countKey,
  } = reportType;

  const result = d;
  const entities = result && result[result.sequence[0]].returnData.entities;
  const color = entities && getRandomUniqueColor(entities.length);
  let labels = [];
  const dataSet = [];
  const dataObj = result && result[result?.sequence[0]].returnData?.graphdata;
  const resultLabels = Object.keys(dataObj);
  labels = resultLabels;
  const staticLables = ["Positive", "Neutral", "Negative"];
  staticLables.forEach((lab, idx) => {
    const data = [];
    const barThickness = "flex";
    const borderColor = color[idx];
    const backgroundColor = color[idx];
    const borderWidth = 1;
    let label = lab;

    entities && entities.forEach((ent) => {
      if (dataObj[ent.entity_name].hasOwnProperty(lab)) {
        if (parseInt(dataObj[ent.entity_name][lab][countKey]) > 0) {
          const currValEnt = parseInt(dataObj[ent.entity_name][lab][countKey]);
          data.push(currValEnt);
        }
      }
      else {
        data.push(0);
      }
    });
    dataSet.push({ label, backgroundColor, barThickness, borderColor, borderWidth, data, fill: false, lineTension: 0 });
  });
  return ({ labels, datasets: dataSet });
}



